import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (min-width: ${breakpoints.sm}px) {
        flex-direction: row;
        gap: ${rem(40)};
        align-items: unset;
    }
`;

export const ContactPerson = styled.div`
    width: ${rem(310)};
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.15);
    border-radius: ${rem(16)};
    padding: ${rem(25)};
    margin: 0 0 ${rem(80)} 0;

    @media (min-width: ${breakpoints.sm}px) {
        margin: ${rem(100)} 0;
    }
`;

export const ContactPersonLabel = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h4};
    font-family: ${({ theme }) => theme.fonts.fontSecondary};
    display: block;
    padding-bottom: ${rem(30)};
`;

export const ContactPersonImage = styled.img`
    width: ${rem(260)};
    border-radius: ${rem(16)};
    margin-bottom: ${rem(20)};
`;

export const ContactPersonName = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    display: block;
    font-family: ${({ theme }) => theme.fonts.fontSecondary};
    padding-bottom: ${rem(15)};
`;

export const ContactPersonDescription = styled.span`
    color: ${({ theme }) => theme.colors.grey};
    display: block;
    padding-bottom: ${rem(10)};
`;

export const ContactPersonPhone = styled.a`
    color: ${({ theme }) => theme.colors.grey};
`;
